import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useBrand } from '../branding/BrandProvider';
import './payment-return.css';

export default function PaymentCancelPage() {
  const navigate = useNavigate();
  const { name: brandName, logos } = useBrand();
  const brandLogo = logos?.fullLarge || logos?.full || logos?.fullWhite;
  const brandAlt = brandName || 'Logo';
  return (
    <main className="payment-return-page">
      <div className="payment-return-container">
        {brandLogo && <img src={brandLogo} alt={brandAlt} className="payment-return-logo" />}
        <div className="payment-card">
          <div className="payment-icon warning">!</div>
          <h1>Payment not completed</h1>
          <p>Your payment was canceled. You can return to select a package when you are ready.</p>
          <div className="payment-actions">
            <button className="cta-btn" type="button" onClick={() => navigate('/select-plan')}>
              Back to packages
            </button>
            <button className="cta-btn--ghost" type="button" onClick={() => navigate('/login')}>
              Back to sign in
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
